import { Modal } from "@mantine/core";
import { useGetApi } from "src/hooks";

import ManagementTable from "../../ManagementTable/ManagementTable";
import YachtDetails from "../YachtDetails/YachtDetails";

interface Props {
  opened: boolean;
  close: () => void;
  refetch: () => void;
  yachtid: string;
  params: any;
}

const mapSubscriptions = (data: any): any => {
  return data.data.map(el => ({ ...el, active: el.active ? "Yes" : "No" }));
};

const SubModal = ({ opened, close, refetch, yachtid, params }: Props) => {
  // const methods = useForm();
  // const { orgid, clid } = useParams();
  // const { post } = usePostApi();

  const { data, isLoading } = useGetApi({
    request: "get-yacht-subscriptions",
    body: {
      params: {
        yachtid,
      },
    },
    mapper: mapSubscriptions,
  });

  return (
    <Modal
      size={"1200px"}
      opened={opened}
      onClose={close}
      title="Subscriptions">
      {/* <div style={{ display: "flex", border: "1px solid red" }}> */}
      <div style={{ marginBottom: 20 }}>
        <YachtDetails
          params={params}
          type="Subscriptions"
          contentOnly
          columns={2}
        />
      </div>
      <ManagementTable
        section="_yachtSubscriptions"
        data={data ?? []}
        loading={isLoading}
      />
      {/* </div> */}

      {/* <Grid>
            <Grid.Col span={6}>
            <FormProvider {...methods}>
                <Flex
                maw="600px"
                w="100%"
                direction="column"
                align="center"
                mx="auto"
                mt={30}
                gap={10}>
                {vesselParticularsFields.map((field, i) => (
                    <InputStyledWrapper key={field.name}>
                    <Text fz={"sm"} w="50%">
                        {field.label}
                    </Text>
                    {field.type === "date" ? (
                        <DatePickerInput
                        w="50%"
                        control={methods.control}
                        name={field.name}
                        />
                    ) : (
                        <Input
                        w={"50%"}
                        {...methods.register(field.name)}
                        readOnly={false}
                        />
                    )}
                    </InputStyledWrapper>
                ))}
                <InputStyledWrapper>
                    <Text fz={"sm"} w="50%">
                    Logbook Working Language
                    </Text>
                    <Input w={"50%"} {...methods.register("lblang")} readOnly={false} />
                </InputStyledWrapper>
                <VesselTypeInput />
                <InputStyledWrapper>
                    <Text fz={"sm"} w="50%">
                    Transform all entries to uppercase
                    </Text>
                    <Switch
                    name="uppercase"
                    control={methods.control}
                    disabled={false}
                    />
                </InputStyledWrapper>
                </Flex>
                <Flex justify={"flex-end"} gap={"sm"} mt={"sm"}>
                <Button onClick={close}>Cancel</Button>
                <Button
                    color="green"
                    onClick={methods.handleSubmit(handleFormSubmit)}>
                    Create
                </Button>
                </Flex>
            </FormProvider>
            </Grid.Col>
            <Grid.Col span={6}></Grid.Col>
        </Grid> */}
    </Modal>
  );
};

export default SubModal;
